// extracted by mini-css-extract-plugin
export default {"wrap":"ItemHasErr_wrap__EW1yE"};